function o(n) {
  let t = "";
  const e = new Uint8Array(n);
  for (let r = 0; r < e.byteLength; r++)
    t += String.fromCharCode(e[r]);
  return btoa(t);
}
export {
  o as arrayBufferToBase64
};
